import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const UserIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g>
      <path
        d="M 107.161458 133.268229 C 136.067708 99.934896 172.916667 75.390625 223.307292 85.15625 C 365.429688 112.890625 338.085938 308.333333 197.526042 317.1875 C 83.658854 324.283854 41.080729 151.822917 133.007812 127.604167 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 176.041667 135.481771 C 222.981771 88.606771 276.953125 177.734375 220.117188 202.929688 C 175.651042 222.65625 148.697917 173.111979 176.041667 144.010417 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 149.088542 291.796875 C 167.057292 206.119792 254.166667 200.390625 254.166667 300.195312 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
    </g>
  </SvgIcon>
);

export default UserIcon;
